import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export const ExcelUpload = (file, response) => {
  const reader = new FileReader();
  reader.onload = (event_) => {
    const bstr = event_.target.result;
    const wb = XLSX.read(bstr, { type: 'binary' });
    const dataArray = [];
    wb.SheetNames.forEach((s) => {
      const ws = wb.Sheets[s];
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 2,
        defval: '',
      });
      dataArray.push(data);
    });
    response(dataArray, file);
  };
  reader.readAsBinaryString(file);
};
